module.exports = __webpack_public_path__ + "static/media/take-away-brown.3fa4a464.svg";